// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rP","text":"rQ","subText":"rR","toggleContainer":"rS","checked":"rT"};